import React from "react";
import { Button, Form } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import "yup-phone";

export default function RegistrationStepOne({ data, incrementStep }) {
  const validationSchema = Yup.object().shape({
    guardianPhone1: Yup.string()
      .matches(/^\d{11}$/, "Only 11 digits allowed")
      .required("Required"),
    guardianPhone2: Yup.string()
      .matches(/^\d{11}$/, "Only 11 digits allowed")
      .required("Required"),
    guardianAddress1: Yup.string().required("Required"),
    guardianCity: Yup.string().required("Required"),
    guardianPostcode: Yup.string()
      .required("Required")
      .matches(
        "^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$",
        "Invalid Postcode"
      ),
  });

  return (
    <Formik
      initialValues={data}
      validationSchema={validationSchema}
      onSubmit={(values) => incrementStep(values)}
    >
      {({ values, handleChange, handleSubmit }) => (
        <div className="registration-step-1">
          <h5 className="mb-3">Parent/Guardian's Details:</h5>
          <Form onSubmit={handleSubmit}>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Phone Number 1</Form.Label>
                <Form.Control
                  type="tel"
                  name="guardianPhone1"
                  placeholder="Enter your phone number (01234567890)"
                  value={values.guardianPhone1}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="guardianPhone1"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>Phone Number 2</Form.Label>
                <Form.Control
                  type="tel"
                  name="guardianPhone2"
                  placeholder="Enter your phone number (01234567890)"
                  value={values.guardianPhone2}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="guardianPhone2"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>Address Line 1</Form.Label>
                <Form.Control
                  type="text"
                  name="guardianAddress1"
                  placeholder="Enter your street address"
                  value={values.guardianAddress1}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="guardianAddress1"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>Address Line 2</Form.Label>
                <Form.Control
                  type="text"
                  name="guardianAddress2"
                  placeholder="Enter your street address"
                  value={values.guardianAddress2}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="guardianAddress2"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex flex-wrap">
              <div className="mb-3 me-md-3 me-0 flex-grow-1">
                <Form.Label>City</Form.Label>
                <Form.Control
                  type="text"
                  name="guardianCity"
                  placeholder="Enter your city"
                  value={values.guardianCity}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="guardianCity"
                  component="p"
                  className="error-message"
                />
              </div>
              <div className="mb-3 flex-grow-1">
                <Form.Label>Postcode</Form.Label>
                <Form.Control
                  type="text"
                  name="guardianPostcode"
                  placeholder="Enter your postcode"
                  value={values.guardianPostcode}
                  onChange={handleChange}
                />
                <ErrorMessage
                  name="guardianPostcode"
                  component="p"
                  className="error-message"
                />
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <Button variant="primary" type="submit">
                Next
              </Button>
            </div>
          </Form>
        </div>
      )}
    </Formik>
  );
}
